//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Language',
  data: function data() {
    return {
      activeLanguage: '',
      arrLanguage: {
        'zh': '中文(简体)',
        'en': 'English'
      }
    };
  },
  created: function created() {
    this.activeLanguage = this.arrLanguage[$i18n.locale];
  },
  methods: {
    selectLanguage: function selectLanguage(e) {
      var arr = e.split('-');
      this.activeLanguage = arr[1];
      window.localStorage.setItem('language', arr[0]);
      $i18n.locale = arr[0];
    }
  }
};